module.exports = __webpack_public_path__ + "img/notifications.11f45fbd.svg";